<template>
  <div id="production-calendar">
    <h3 class="title mb-0">PRODUCCION POR RANGO DE FECHAS</h3>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-10">
          <input class="mt-5 w-100 mb-3" type="date" v-model="initDate"/>
        </div>
        <div class="col-10">
          <input class="w-100 mb-1" type="date" v-model="endDate"/>
        </div>
        <div class="col-10">
          <button class="mt-4 d-block button-app-big w-100" type="button" @click="searchDate(initDate, endDate)">
            Consultar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductionCalendar',
  data() {
    return {
      initDate: '',
      endDate: ''
    }
  },
  methods: {
    searchDate(initDate, endDate) {
      if (!initDate || !endDate) {
        alert('Por favor seleccione ambas fechas')
        return
      }

      // Formatear fechas como YYYY-MM-DD
      const formattedInitDate = this.formatDateForAPI(initDate)
      const formattedEndDate = this.formatDateForAPI(endDate)

      if (formattedInitDate && formattedEndDate) {
        this.$router.push(`/production/calendar-result/${formattedInitDate}/${formattedEndDate}`)
      }
    },
    formatDateForAPI(dateString) {
      if (!dateString) return ''
      //const date = new Date(dateString)
      const date = new Date(dateString + 'T00:00:00')
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/ProductionCalendar.vue